import { useMemo } from 'react';
import _keyBy from 'lodash/keyBy';

import { PersonOutline } from '@lyearn/icons';
import { FilterOption } from '@/components/Filter/types';
import { UseFilterValuesParams } from '@/components/FilterNew/types';
import { UserStatusEnum } from '@/types/schema';

import { getUserFilterOption } from '../../utils';
import useUsersFilter from '../useUsersFilter';

export const USER_ME_FILTER = { property: 'ly__userId_me', label: 'Me' };

export const ME_OPTION = {
  value: USER_ME_FILTER.property,
  label: USER_ME_FILTER.label,
  name: USER_ME_FILTER.label,
  Icon: PersonOutline,
};

const useUserFilterValue = ({ value, tagValuesStore }: UseFilterValuesParams) => {
  const { idsToFetch, meIndex } = useMemo(
    () => ({
      idsToFetch: value.filter((id) => id !== USER_ME_FILTER.property && !tagValuesStore?.[id]),
      meIndex: value.findIndex((id) => id === USER_ME_FILTER.property),
    }),
    [tagValuesStore, value],
  );

  const { isLoading: fetching, users: usersData } = useUsersFilter({
    filters: { ids: idsToFetch, status: [UserStatusEnum.Active, UserStatusEnum.Archived] },
    pageSize: idsToFetch.length,
    pause: !idsToFetch.length,
  });

  const { resolvedValue, selectedOptions } = useMemo(() => {
    // @ts-ignore
    const users: Record<string, (typeof usersData)[0]> = {
      ...tagValuesStore,
      ..._keyBy(usersData, 'id'),
    };
    const valuesWithoutMe = value.filter((id) => id !== USER_ME_FILTER.property && users[id]);
    const resolvedValue = valuesWithoutMe.map((id) => users[id].name || '');
    const selectedOptions: FilterOption[] = valuesWithoutMe.map((id) =>
      getUserFilterOption(users[id]),
    );
    return { resolvedValue, selectedOptions };
  }, [tagValuesStore, usersData, value]);

  if (meIndex !== -1) {
    return {
      resolvedValue: ['Me', ...resolvedValue],
      selectedOptions: [ME_OPTION, ...selectedOptions],
    };
  }

  return { fetching, resolvedValue, selectedOptions };
};

export default useUserFilterValue;
